export default __webpack_public_path__ + "static/media/mon_256.51a4dca7.png";